// src/components/pages/EventManager/EventDetailPage.js

import React from "react";
import { useLocation } from "react-router-dom";
import { Container, Typography, Grid, Box } from "@mui/material";
import { useTheme } from "styled-components";
import SubmissionCard from "../../molecules/ChallengeSubmission/SubmissionCard";

const EventDetailPage = () => {
  const location = useLocation();
  const { event } = location.state || {};
  const theme = useTheme();

  console.log("event: ", event);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, fontFamily: "basic-sans" }}>
      {event ? (
        <>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontFamily: "basic-sans" }}
          >
            {event.title}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            sx={{ fontFamily: "basic-sans" }}
          >
            {event.description}
          </Typography>

          {/* Render event content if available */}
          {event.content && event.content.length > 0 ? (
            <>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ fontFamily: "basic-sans", mt: 4 }}
              >
                Event Content
              </Typography>

              <Box
                sx={{     
                  mb: 8,
                  borderBottom: `1px solid ${theme.colors.darkGray}`,
                }}
              ></Box>
              <Grid container spacing={4}>
                {event.content.map((submission) => (
                  <Grid item xs={12} sm={6} md={4} lg={4} key={submission.id}>
                    <SubmissionCard submission={submission} />
                  </Grid>
                ))}
              </Grid>
            </>
          ) : (
            <Typography variant="body2" sx={{ mt: 2 }}>
              No content available for this event.
            </Typography>
          )}
        </>
      ) : (
        <Typography variant="h6" color="error">
          No event data available.
        </Typography>
      )}
    </Container>
  );
};

export default EventDetailPage;
